import { cn } from "@/lib/utils";
import { useMatches,useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import ThaloLogo from "@/assets/thalo-light.png";
import { ArrowLeft, HelpCircle, Info } from "lucide-react";


export function InstallFlowNav({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  const matches = useMatches();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const ref = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (isMobile) {
      ref.current?.scrollIntoView({ behavior: "smooth", inline: "end"})
    }
  }, [matches]);
  const handleGoBackClick = () => {
    window.history.back();
  };
  return (
    <nav
      className={cn(
        "bg-[#011E90] flex items-center justify-between space-x-4 lg:space-x-6 h-[60px] px-4",
        className
      )}
      {...props}
    >
      <ArrowLeft size={28} color="white"
      onClick={handleGoBackClick} />
     <img src={ThaloLogo} className="w-[120px] h-[27px]" alt="Logo"/>
      <HelpCircle size={28} color="white" />
    </nav>
  );
}
